import {takeLatest, call, put, select} from 'redux-saga/effects';
import {
  sync,
  syncRequest,
  syncSuccess,
  syncFailure,
  setPendingChangesFlag
} from '../actions/ui/sync';
import {
  saveAccountSuccess,
  removeAccountSuccess
} from '../actions/entities/accounts';
import {
  saveTransactionSuccess,
  removeTransactionSuccess, saveTransactionWithChangedCategorySuccess
} from '../actions/entities/transactions';
import {loadAccountsSaga} from './accounts';
import {loadTagsSaga} from './categories';
import {loadFilterTransactionsSaga, loadRecentTransactionsSaga} from './transactions';
import AccountsStorage from '../util/storage/accounts';
import TransactionsStorage from '../util/storage/transactions';
import TagsStorage from '../util/storage/categories';

export function* syncSaga() {  
  yield put(syncRequest());
  try {
    yield call(AccountsStorage.sync);
    yield call(TransactionsStorage.sync);
    yield call(TagsStorage.sync);
    yield loadRecentTransactionsSaga();
    yield loadFilterTransactionsSaga();
    yield loadAccountsSaga();
    yield loadTagsSaga();
    yield put(syncSuccess());
  } catch (error) {
    yield put(syncFailure(error));
  }
}

export function* setPendingChangesFlagSaga() {
  yield put(setPendingChangesFlag());
}

export default [
  takeLatest(sync, syncSaga),
  takeLatest(saveAccountSuccess, setPendingChangesFlagSaga),
  takeLatest(removeAccountSuccess, setPendingChangesFlagSaga),
  takeLatest(saveTransactionSuccess, setPendingChangesFlagSaga),
  takeLatest(saveTransactionWithChangedCategorySuccess, setPendingChangesFlagSaga),
  takeLatest(removeTransactionSuccess, setPendingChangesFlagSaga)
];
